import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';

import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { SelfService } from '../self-services.service.ts';
import { LandingPaginationDTO , DataService  } from "../../bpg-common/services/data.services";
import { BpgCommonService } from '../../bpg-common/services/bpg-common.service';
import { ConstantValues } from '../../bpg-common/models/bpg-constants';
import { UploadService } from './../d-i/upload.service';
import { ImageCroppedEvent } from 'ngx-image-cropper';

@Component({
  selector: 'app-naac',
  templateUrl: './naac.component.html',
  styleUrls: ['./naac.component.css']
})

export class NaacComponent implements OnInit {

  constructor(
    private readonly  router: Router,
    private readonly spinnerService: Ng4LoadingSpinnerService,
    private readonly naacService: SelfService,
    private readonly environment: EnvironmentConfiguration,
    private readonly bpgCommonService: BpgCommonService,
    private readonly uploadService: UploadService,
    private readonly data: DataService) { }

  @ViewChild('myInput', { static: false })
  myInputVariable: ElementRef;
  @ViewChild('myInputBanner', { static: false })
  myInputBannerVariable: ElementRef;
  method: string;
  param: string;
  param1: string;

  msg1: string;
  editandSavebtn = false;
  savebtn = false;
  adminId: any = localStorage.getItem('adminId');
  loginDetails: any = JSON.parse(localStorage.getItem("loginData"));
  fileTypeConstant = 'JPEG or PNG';
  //Naac details Section
  naacDetailsSuccess = false;
  naacDetailsUpdate = false;
  naacDetailsCheck = false;
  selectedFileforBanner: File = null;
  uploadFileNameBanner: string = this.fileTypeConstant;
  naacBannerImage = '';
  isUploadBannerImage = false;
  isLoaderBannerStop = false;
  isbannerimageLoaded = false;
  naacMasterList: any;
  bannerImageExtensionError = false;
  bannerResponseList: any;
  naacVision: string = null;
  naacAffinity: string = null;
  naacDetailsList: any = [];
  naacBannerId: any = 0;
  isLoaderNaacLogoStop = false;
  naacLogo: string;
  naacLogoImage = '';
  isUploadnaacLogoImage = false;
  uploadFileNamenaacLogo: string = null;
  uploadnaacLogoDone = false;
  uploadFileExtensionnaacLogo = false;

  //news section
  newsTitle: string;
  newsDesc: string;
  newsLink: string;
  newsImage: string;

  newsFile: File;
  selectedFileNameforNews: string = this.fileTypeConstant;
  naacNewsList: any;
  naacNewsTable = false;
  noNewsTable = false;
  deleteNews = false;


  saveAndUpdateNews = false;
  saveNews = true;
  newsId: any;
  newsLinkValid = false;
  naacNewsSuccess = false;
  naacNewsId: any = 0;
  newsSearchKey: any;
  firstEditNews = true;
  uploadFileExtensionNewsImage = false;
  isUploadnewsImage = false;
  isLoadernewsImageStop = false;
  imageCheck = false;
  uploadFileNamenewsImage: string = null;
  naacNewsImage: string;
  uploadnewsImageDone = false;
  newsImageHeight = '';
  newsImageWidth = '';
  //resource section
  deleteResource = false;
  noResourceTable = false;
  naacResourceTable = false;
  addResouceTitle: string;
  additionalDesc: string = null;
  addResourceDocument: string;
  resourceOrder: number;
  folderNameList: any = [];
  selectedFolder: string;
  landingData: any;
  folderId: number;
  folderName: string;
  naacResouceList: any;
  errorMessageResourceActive = false;
  errorMessageResource: any;
  naacResourceSuccess = false;
  isFolderSectionClicked: any;

  resourceSearchKey: any;
  firstEditResource = true;
  naacResourceId: any;
  saveResource = true;
  saveAndUpdateResource = false;
  uploadDocumentType = "Upload document(< 500MB)";
  ResourcefileName: string = this.uploadDocumentType;
  fileSize: number;
  fileExtension: any;
  fileSizeExtensionError = false;
  selectedFile: File = null;
  UploadDocument: any;
  isuploaded = true;
  fileList: File[] = [];
  timeOutError = false;
  isFileUploded = false;
  //regional
  naacReTeamList: any;
  uploadFileExtension = false;
  uploadFileExtensionUser = false;
  uploadImageDone = false;
  isLoaderStop = false;
  isUploadImage = false;
  reTeamEamilValid = false;
  reTeamFlag: any;
  saveReTeam = true;
  saveAndUpdateReTeam = false;
  errorMessageRegionalActive = false;
  errorMessageRegional: any;
  firstEditReTeam = true;
  deleteRegional = false;
  noReginalTbale = false;
  uploadFileNameUser: string = null;
  naacReTeamTable = false;
  regionalDesignation: string;
  userId: any = this.loginDetails['userId'];
  name: string
  emailId: string;
  userPic: string;
  userFirstName: string;
  reTeamOrder: number;
  naacPronoun: string;
  siteList: any = [];
  siteName: any = [];
  siteNameList: any = [];
  uploadUserPicImageDone = false;
  isLoaderUserPicStop = false;
  isUploadUserPicImage = false;
  naacUserImage: string = null;
  naacReTeamId: string;
  naacReteamSuccess = false;


  reTeamSearchKey: any;
  //dashboard section
  affinityList: any = [];
  affinityResponse: any = [];
  bpgName: any;
  bpgId: any;
  naacDate: any = null;
  naacStatus: string;
  selectedBpg: string;
  affinityErrorMsg: string;
  affinitySuccess = false;

  affinityUpdate = false;
  errorAffinity = false;
  affinityTable = true;
  naacAffinityList: any = [];
  noAffinityTable = false;
  naacEdit = false;
  deleteAffinity = false;
  selectedNews: any = [];
  selectedReteam: any = [];
  selectedResource: any = [];
  naacPublishSuccess = false;

  searchTerm: any;
  LandingPaginationDTO: LandingPaginationDTO = new LandingPaginationDTO();
  userList: any;
  noUser: boolean;
  search: boolean;
  userFound: boolean;
  limit: number = ConstantValues.pageLimit;
  currentShowingElementsAffinity: number = ConstantValues.pageLimit;
  currentShowingElementsNews: number = ConstantValues.pageLimit;
  currentShowingElementsResource: number = ConstantValues.pageLimit;
  currentShowingElementsReTeam: number = ConstantValues.pageLimit;
  currentShowingElementsNaac: number = ConstantValues.pageLimit;
  tableShow: boolean;
  numberOfElements: any;
  noDataFound: boolean;
  deleteSuccess = false;
  width: number;
  height: number;
  lbl: any;
  RePic: any;
  currentPage = 1;
  lbl2: any
  di: any;
  order: number;
  showReset = false;
  saveMasterBtn = false;
  naacId: any = 0;
  timeoutErrorMessage: string = ConstantValues.timeoutErrorMessage;
  failureOnResourceUpload = false;
  butDisabled = true;
  awsUrls: any;
  resourceData: any;
  uploadFlag: any;
  errorMsgUploadSave = false;
  errorMsgUploadSaveUpdate = false;

  disableAffinity = false;
  //Image Cropper
  imageChangedEvent: any = '';
  imageChangedEventBanner: any = '';
  croppedImage: any = '';
  imageTypeName: string = null;


  isNewsPageClicked  = false;
  isResourcePageClicked  = false;
  isRegionalPageClicked  = false;

  isNaacAdmin = false;
  removeToolbar: any = { toolbar: 'Basic', uiColor: '#FFFFFF', basicEntities: false, fillEmptyBlocks: false, removeButtons: 'Source,Save,NewPage,Preview,Print,Templates,Pasteas plain text,PastefromWord,Find,Replace,SelectAll,Form,Checkbox,Radio,TextField,Textarea,SelectionField,Button,ImageButton,HiddenField,Italic,Decrease,Increase,Block,Create Div Container,Text direction from left to right,Text direction from right to left,Set language,Link,Unlink,Image,Flash,Table,Horizontal,Smiley,Insert Special Character,Insert Page Break for Printing,IFrame,Formatting,Paragraph,Font,FontSize,TextColor,BackgroundColor,Maximize,ShowBlocks,About,forceSpellChecker,Cut,Copy,Paste,Undo,Redo,Anchor,Underline,Strike,Subscript,Superscript,Bold,RemoveFormat' }
  msgConstant = " Are you sure you want to update ? "
  dataToggleConstant = 'data-toggle';
  dataTargetConstant = 'data-target';
  msg1Constant = " Are you sure you want to Save ? ";
  msg2Constant = " Your current changes will be discarded, do you want to continue ? ";
  fileType1Constant = "image/jpeg";
  ngOnInit() {
    if (this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod') {
              if (localStorage.getItem('loginData')=== null || localStorage.getItem('loginData')=== undefined) {

        this.router.navigate(['/log-out']);
      }
    }
    localStorage.removeItem('searchedEventsCaledarItems');
    if(localStorage.getItem('isNaacAdmin') === 'true')
    {
      this.isNaacAdmin = true
    }
    if (this.adminId !== "1" && this.adminId !== "4" && !this.isNaacAdmin) {
      this.router.navigate(['/site-home']);
    }
    this.logUserAction();
    this.saveMasterBtn = true;

    this.getnaacBannerList();
    this.getallSite();
    this.getAllAffinity();
    this.getnaacnewsList();
    this.getnaacREteam();
    this.getNaacResouceList();
    this.getnaacAffinityList();
    this.getNaacFolderList();
    this.bpgCommonService.getSessionToken();
    this.imageChangedEvent = '';
    this.imageChangedEventBanner = '';
    this.croppedImage = '';
    this.uploadFileExtensionUser = false;
    document.getElementById("base64textareaUser").textContent = '';
    document.getElementById("filenameUserPic").textContent = this.fileTypeConstant;
    document.getElementById("filenamenaacLogo").textContent = this.fileTypeConstant;
    document.getElementById("base64textareanaacLogo").textContent = '';
    document.getElementById("filenamenewsImage").textContent = this.fileTypeConstant;
    document.getElementById("base64textareanewsImage").textContent = '';
    this.uploadFileExtensionnaacLogo = false;
    this.isUploadImage = false;
    this.isLoaderStop = false;
    this.naacUserImage = null;
    this.naacLogoImage = '';
    this.uploadImageDone = false;
    this.uploadUserPicImageDone = false;
    this.isLoaderUserPicStop = false;

    this.isUploadUserPicImage = false;
    this.isUploadBannerImage = false;
    this.isLoaderBannerStop = false;
    this.isLoaderNaacLogoStop = false;
    this.uploadnaacLogoDone = false;
    this.isUploadnaacLogoImage = false;
    this.isUploadnewsImage = false;
    this.isLoadernewsImageStop = false;
    this.uploadnewsImageDone = false;
    this.naacNewsImage = '';
    this.uploadFileExtensionNewsImage = false;

    this.data.folderSection.subscribe(myData => {
      this.isFolderSectionClicked = myData;
    })

  }


  /** get all site list
     * @class allSite
     * @method   getallSite(){
  
     */
  getallSite() {
    this.naacService.getAllSite().subscribe(data => {
      this.siteList = data;
    })
  }

  /** get all affinity list
   * @class allAffinity
   * @method   getAllAffinity(){

   */
  getAllAffinity() {
    const landingDto = {
      "filter": {  "adminId":this.adminId,
      "userId" : this.loginDetails.userId},
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "",
      "uid": "",
    };
    this.naacService.getAllNaac(landingDto).subscribe(data => {
      this.affinityList = data;
      if((this.adminId === "4" || this.isNaacAdmin) && this.affinityList[0].checkAffinity != null)
      {
        this.disableAffinity = true;
      }
    })
  }

  /** get banner image list
   * @class BannerImage
   * @method getdiBannerList
   */
  getnaacBannerList() {
    this.spinnerService.show();
    this.LandingPaginationDTO = {
      "filter": { "naacFlag": "naacSelfService" },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 50,
      "sortDirection": "ASC",
      "sortProperty": "naacId",
      "uid": ""
    }
    this.naacService.getnaacBannerList(this.LandingPaginationDTO).subscribe(data => {
      this.bannerResponseList = data.content;
      this.deleteSuccess = false;
      this.spinnerService.hide();
      this.numberOfElements = data.totalElements;
      if (this.bannerResponseList.length === 0){
        this.noDataFound = true;
      }
      else {
        this.noDataFound = false;
      }
    });
  }


  /** to clear data
   * @class DIComponent
   * @method clearAlerts
   */
  clearAlerts() {
    this.noUser = false;
    this.userFound = false;
  }

  /** to list users other than admins
  * @class naacComponent
  * @method getUserList
  */
  getUserList() {
    this.naacReteamSuccess = false;
    this.deleteRegional = false;
    this.LandingPaginationDTO.filter = { "leadershipPosition": "USER" };
    this.naacService.getUserDropDown(this.LandingPaginationDTO).subscribe(data => {
      this.userList = data;
      if (this.userList.length === 0) {
        setTimeout(() => {
          window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 500);
        this.noUser = true;
        this.userFirstName = null
        this.emailId = null
        this.butDisabled = true;
      } else {
        this.butDisabled = false;
        if (this.search) {
          setTimeout(() => {
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
          }, 500);
          this.userFound = true;
        }
        this.userList.map((i) => { i.userFirstName = `${i.userFirstName} ${i.userLastName}`; return i; })
      }
    }, _err => {
    });


  }

  /** to select the user acc to search
  * @class naacComponent
  * @method userSelection
  */
  userSelection(user) {
    this.userFound = false;
    for (const list of this.userList) {

      if (list != null) {
        if (user.userId === list.userId) {
          this.userId = list.userId;
          this.name = list.userFirstName;
          this.emailId = list.emailId;
          this.reTeamEamilValid = false;
        }
      }
    }

  }

  /** to sumbit naac master
  * @class naacComponent
  * @method onNaacMasterSubmit
  */
  public onNaacMasterSubmit() {
    if (this.uploadFileExtension === true) {
      this.removeModal();
      return;
    }
    if (this.saveMasterBtn === true) {
      this.setModal();
      this.popupModal()
      document.getElementById('masterSave').click();
    }

  }

  popupModal() {
    this.method = "saveMaster";
    this.param = '';
    this.msg1 = this.msgConstant;
  }

  setModal() {
    document.getElementById('masterSave').setAttribute(this.dataToggleConstant, 'modal');
    document.getElementById('masterSave').setAttribute(this.dataTargetConstant, '#myModal');
  }
  removeModal() {
    document.getElementById('masterSave').removeAttribute(this.dataToggleConstant);
    document.getElementById('masterSave').removeAttribute(this.dataTargetConstant);
  }

  /** to submit Dashboard Details
   * @class NaacComponent
   * @method onDashboardSubmit
   */
  public onDashboardSubmit(status) {

    if (status === 'Draft') {
      this.method = "addDashboard";
      this.param = status;
      this.msg1 = " Are you sure you want to save ? ";

    }
    else {
      this.method = "addDashboard";
      this.param = status;
      this.msg1 = " Are you sure you want to publish NAAC ? ";
    }
  }
  /** to save/update dashboard
  * @class NaacComponent
  * @method addDashboard
  */

  addDashboard(status) {
    if (status === 'Draft') { this.naacStatus = null; }
    else { this.naacStatus = 'Publish' }
    this.spinnerService.show();
    let selectedbpgName;
    for (const affinity of this.affinityList) {
      if (affinity.bpgId === this.selectedBpg) {
         selectedbpgName = affinity.bpgName;
        break
      }
    }
    const affinityData = {
      "naacId": this.naacId,
      "naacAffinityId": this.selectedBpg,
      "id": this.loginDetails.userId,
      "naacDate": this.naacDate,
      "naacAffinityName": selectedbpgName,
      "naacStatus": this.naacStatus
    }

    this.naacService.naacAddAffinity(affinityData).subscribe(data => {
      if (data.message != null) {
        this.affinityErrorMsg = data.message;
        this.errorAffinity = true;
        this.getnaacAffinityList();
      }
      else if (data.naacStatus === "Draft") {
        if (this.naacEdit === true) {
          this.affinitySuccess = false;
          this.affinityUpdate = true;

        }
        else {
          this.affinitySuccess = true;
          this.affinityUpdate = false;

        }

        this.errorAffinity = false;
        this.naacId = data.naacId;
        localStorage.setItem("naacId", this.naacId);
        this.deleteAffinity = false;
        this.getnaacAffinityList();

      }

      else if (data.naacStatus === "Publish") {
        this.naacPublishSuccess = true;
        this.naacDetailsUpdate = false;
        this.naacDetailsSuccess = false;
        this.naacNewsSuccess = false;
        this.naacResourceSuccess = false;
        this.naacReteamSuccess = false;
      }
      setTimeout(() => {
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      }, 200);
      this.spinnerService.hide();


    })

  }
  onPublishNaac(data) {
    this.method = "publishNaac";
    this.param = data;
    this.msg1 = " Are you sure you want to publish NAAC ? ";
  }

  public publishNaac(data) {
    this.spinnerService.show();

    const affinityData = {
      "naacId": data.naacId,
      "naacAffinityId": data.naacAffinityId,
      "id": this.loginDetails.userId,
      "naacDate": data.naacDate,
      "naacAffinityName": data.naacAffinityName,
      "naacStatus": 'Publish'
    }

    this.naacService.naacAddAffinity(affinityData).subscribe(data => {
      if (data.message != null) {
        this.affinityErrorMsg = data.message;
        this.errorAffinity = true;
      }
      else {
        this.naacPublishSuccess = true;
        this.getnaacAffinityList();
      } setTimeout(() => {
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      }, 200);
      this.spinnerService.hide();


    })


  }





  /** to submit news
  * @class DIComponent
  * @method onNewsSubmit
  */
  public onNewsSubmit() {

    if (this.saveAndUpdateNews === true) {
      this.method = "addNews";
      this.param = '';
      this.msg1 = this.msgConstant;
    }
    else {
      this.method = "addNews";
      this.param = '';
      this.msg1 = this.msg1Constant;
    }
  }

  /** to save/update news
  * @class DIComponent
  * @method addNews
  */
  addNews() {
    this.spinnerService.show();
    if (this.uploadFileNamenewsImage != null && this.uploadFileNamenewsImage !== undefined && this.uploadFileNamenewsImage !== '')
      {
        this.imageCheck = true;
      }
    if (!this.saveAndUpdateNews){
      this.newsId = 0;

    }
    const newsData = {
      "naacNewsTitle": this.newsTitle,
      "naacNewsDesc": this.newsDesc,
      "naacNewsLink": this.newsLink,
      "id": this.loginDetails.userId,
      "newsImage": this.uploadFileNamenewsImage,
      "naacImageCheck": this.imageCheck,
      "naacNewsId": this.newsId,
      "naacId": this.naacId,
      "naacNewsImage": this.naacNewsImage
    }

    this.naacService.addnaacNews(newsData).subscribe(data => {
      if (data !== undefined) {
        this.deleteNews = false;
        this.naacNewsSuccess = true;
        this.getnaacnewsList();
      }

      setTimeout(() => {
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      }, 200);
      this.spinnerService.hide();

    });
  }

  /** to submit resource
 * @class NaacComponent
 * @method onResourceSubmit
 */
  public onResourceSubmit() {
    if (this.saveAndUpdateResource === true) {
      this.method = "addResource";
      this.param = '';
      this.msg1 = this.msgConstant;
    }
    else {

      this.naacResourceId = 0;
      this.method = "addResource";
      this.param = '';
      this.msg1 = this.msg1Constant;
    }
  }
  /** to submit resource
  * @class NaacComponent
  * @method onResourceSubmit
  */
  public onNaacMasterSubmitBanner() {

    this.method = "addBanner";
    this.param = '';
    this.msg1 = " Are you sure you want to save ? ";
  }

  public addBanner() {
    const bannerData = {
      "naacId": this.naacId,
      "id": this.loginDetails.userId,
      "naacBanner": this.uploadFileNameBanner,
      "naacBannerImage": this.naacBannerImage,
      "naacVision": this.naacVision,
      "naacAffinity": this.naacAffinity,
      "naacBannerId": this.naacBannerId,
      "naacLogo": this.uploadFileNamenaacLogo,
      "naacLogoImage": this.naacLogoImage
    }
    this.spinnerService.show();
    this.naacService.addnaacMaster(bannerData).subscribe(response => {
      if (response.body.message === 'Error') {
        this.errorMsgUploadSave = true;
      }
      else if (this.naacEdit === true) {
        this.naacDetailsUpdate = true;
        this.naacDetailsSuccess = false;
      }
      else {
        this.naacDetailsSuccess = true;
        this.naacDetailsUpdate = false;
      }
      this.getnaacBannerList();
      setTimeout(() => {
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      }, 200);
      this.spinnerService.hide();
    });


  }

  /** to save/update resource
  * @class NaacComponent
  * @method addResource
  */
  public addResource() {
    this.spinnerService.show();
    const uploadData =
    {
      'category': 'uploadDocument',
    }
    this.uploadFlag = 'naacResource';
    const ResourceData = {
      "naacResourceId": this.naacResourceId,
      "naacId": this.naacId,
      "naacResourceTitle": this.addResouceTitle,
      "naacResourceDesc": this.additionalDesc,
      "naacResourceDocument": this.UploadDocument,
      "id": this.loginDetails.userId,
      "resourceOrder": this.resourceOrder,
      "folderId": this.selectedFolder
    }

    //for edit case
    if (this.saveAndUpdateResource === true) {
      if (this.selectedFile != null) {
        this.spinnerService.show();

        this.bpgCommonService.getAwsUrl(uploadData).subscribe(async data => {
          this.awsUrls = data;
          await this.uploadService.getPresignedUrl(this.selectedFile, this.awsUrls, this.naacResourceId, this.uploadFlag);

          if (localStorage.getItem('uploadError') === 'Error') {
            this.errorMessageResourceActive = false;
            this.errorMsgUploadSaveUpdate = true;
            this.naacResourceSuccess = false;
            this.getNaacResouceList();
            this.getNaacFolderList();

            setTimeout(() => {
              window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
            }, 200);
            this.spinnerService.hide();
            localStorage.removeItem('uploadError')
          }
          else {

            this.naacService.addnaacResource(ResourceData).subscribe(data => {
              this.resourceData = data;
              this.uploadFlag = 'naacResource';
              if (data.message !== undefined) {
                this.errorMessageResource = data.message;
                this.errorMessageResourceActive = true;
                this.errorMsgUploadSaveUpdate = false;
                this.naacResourceSuccess = false;
                setTimeout(() => {
                  window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                }, 200);
              }
              else if (data !== undefined) {
                this.spinnerService.show();
                this.errorMessageResourceActive = false;
                this.naacResourceSuccess = true;

                this.deleteResource = false;
                this.errorMsgUploadSaveUpdate = false;
               
                this.getNaacResouceList();
                this.getNaacFolderList();
                this.spinnerService.hide();

                setTimeout(() => {
                  this.onResetResourceClick();
                }, 3000);

              }
            });
          }
        });
      }
      else {
        //edit no files selected
        this.spinnerService.show();
        this.naacService.addnaacResource(ResourceData).subscribe(data => {
          if (data.message !== undefined) {
            this.errorMessageResource = data.message;
            this.errorMessageResourceActive = true;
            this.naacResourceSuccess = false;
            this.spinnerService.hide();
            setTimeout(() => {
              window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
            }, 200);
          } else if (data !== undefined) {
            this.errorMessageResourceActive = false;
            this.naacResourceSuccess = true;

            this.deleteResource = false;
            this.getNaacResouceList();
            this.getNaacFolderList();
            setTimeout(() => {
              this.onResetResourceClick();
            }, 3000);
            this.spinnerService.hide();
          }
        });


      }
    }
    //if save condition
    else {

      this.spinnerService.show();
      this.naacService.addnaacResource(ResourceData).subscribe(data => {
        this.resourceData = data;
        if (data.message !== undefined) {
          this.errorMessageResource = data.message;
          this.errorMessageResourceActive = true;
          this.naacResourceSuccess = false;
          this.deleteResource = false;
          this.spinnerService.hide();
          setTimeout(() => {
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
          }, 300);
        }
        else if (data !== undefined) {
          this.spinnerService.show();
          this.uploadFlag = 'naacResource';

          if (this.selectedFile != null) {
            this.bpgCommonService.getAwsUrl(uploadData).subscribe(async data => {
              this.awsUrls = data;
              await this.uploadService.getPresignedUrl(this.selectedFile, this.awsUrls, this.resourceData.naacResourceId, this.uploadFlag);
              if (localStorage.getItem('uploadError') === 'Error') {
                const dleteData = {
                  "id": this.resourceData.naacResourceId,
                  "flag": "resource"
                }



                this.naacService.deletenaac(dleteData).subscribe(data => {
                  if (data.flag === "resource") {
                    this.errorMessageResourceActive = false;
                    this.errorMsgUploadSave = true;
                    this.naacResourceSuccess = false;
                    this.getNaacResouceList();
                    this.getNaacFolderList();

                    setTimeout(() => {
                      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                    }, 200);
                  }
                });
                this.spinnerService.hide();
                localStorage.removeItem('uploadError')

              }

              else {
                this.errorMessageResourceActive = false;
                this.naacResourceSuccess = true;
                this.deleteResource = false;
                this.errorMsgUploadSave = false;
                this.getNaacResouceList();
                this.getNaacFolderList();
                setTimeout(() => {
                  this.onResetResourceClick();
                }, 3000);

              }
              this.spinnerService.hide();

            });


          }
        }
      });

    }
  }


  /** to submit ReTeam
 * @class NaacComponent
 * @method onReTeamSubmit
 */
  public onReTeamSubmit() {

    if (this.uploadFileExtensionUser === true) {
      this.removeModalReTeam();
      return;
    }
    if (this.saveAndUpdateReTeam === true) {
      this.setModalReTeam();
      this.popupModalReTeam()
      document.getElementById('UpdateReTeam').click();
    }
    else {
      this.setModalReTeam();
      this.popupModalReTeam()
      document.getElementById('saveReTeam').click();
    }

  }


  popupModalReTeam() {
    if (this.saveAndUpdateReTeam === true) {
      this.method = "addReTeam";
      this.param = '';
      this.msg1 = this.msgConstant;
    }
    else {
      this.method = "addReTeam";
      this.param = '';
      this.msg1 = this.msg1Constant;
    }
  }

  setModalReTeam() {
    if (this.saveAndUpdateReTeam === true) {
      document.getElementById('UpdateReTeam').setAttribute(this.dataToggleConstant, 'modal');
      document.getElementById('UpdateReTeam').setAttribute(this.dataTargetConstant, '#myModal');
    } else {
      document.getElementById('saveReTeam').setAttribute(this.dataToggleConstant, 'modal');
      document.getElementById('saveReTeam').setAttribute(this.dataTargetConstant, '#myModal');
    }
  }
  removeModalReTeam() {
    if (this.saveAndUpdateReTeam === true) {
      document.getElementById('UpdateReTeam').removeAttribute(this.dataToggleConstant);
      document.getElementById('UpdateReTeam').removeAttribute(this.dataTargetConstant);
    }
    else {
      document.getElementById('saveReTeam').removeAttribute(this.dataToggleConstant);
      document.getElementById('saveReTeam').removeAttribute(this.dataTargetConstant);

    }
  }

    /** to reset news
     * @class NaacComponent
     * @method resetNews
     */
     navigateNaacFolder() {
      this.clearAlerts();
      this.method = "navigateNaacFolderClick";
      this.param = '';
      this.msg1 = this.msg2Constant;
    }
    
    navigateNaacFolderClick()
    {
      
      setTimeout(() => {
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      }, 200);
this.router.navigate(['/naac-folder'])
    }
  /** to save/edit reTeam
 * @class NaacComponent
 * @method addReTeam
 */
  addReTeam() {
    if (this.saveAndUpdateReTeam === true) {
      this.reTeamFlag = "updateReTeam"
    }
    else {
      this.reTeamFlag = "saveReTeam";
      this.naacReTeamId = '0'
    }

    this.siteNameList = [];
    if (this.siteName.length > 0) {

      for (const s of this.siteName) {
        if (s.siteName != null && s.siteName !== undefined){
          this.siteNameList.push(s.siteName);}
        else{
          this.siteNameList.push(s);}
      }
    }
    this.spinnerService.show();
    this.naacUserImage = document.getElementById("base64textareaUser").textContent;

    const userData = {
      "id": this.loginDetails.userId,
      "userId": this.userId,
      "naacId": this.naacId,
      "roleName": this.regionalDesignation,
      "emailId": this.emailId,
      "userPic": this.uploadFileNameUser,
      "reTeamPic": this.naacUserImage,
      "regionalOrder": this.reTeamOrder,
      "siteNameList": this.siteNameList,
      "naacPronounce": this.naacPronoun,
      "naacReTeamId": this.naacReTeamId,
      "reTeamFlag": this.reTeamFlag,
    }
    this.naacService.addnaacReTeam(userData).subscribe(data => {
      if (data.message !== undefined) {
        this.errorMessageRegional = data.message;
        this.errorMessageRegionalActive = true;
        this.naacReteamSuccess = false;
        this.noUser = false;
        this.userFound = false;

      } else if (data !== undefined) {
        this.errorMessageRegionalActive = false;
        this.noUser = false;
        this.userFound = false;
        this.naacReteamSuccess = true;

        this.deleteRegional = false;
        this.LandingPaginationDTO.searchTerm = '';
        this.getnaacREteam();
      } setTimeout(() => {
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      }, 200);
      this.spinnerService.hide();

    })
  }


  /** to reset Dashboard
   * @class NaacComponent
   * @method resetDashboard
   */

  resetDashboard() {

    this.naacDate = null;
    this.selectedBpg = null;
    document.getElementById("bpgName").removeAttribute("disabled");


  }

  /** to reset news
     * @class NaacComponent
     * @method resetNews
     */
  resetNews() {
    this.clearAlerts();
    this.method = "onResetNewsClick";
    this.param = '';
    this.msg1 = this.msg2Constant;
  }

  onResetNewsClick() {
    setTimeout(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }, 200);
    this.deleteNews = false;
    this.deleteResetNews();
    this.getnaacnewsList();
  }

  deleteResetNews() {
    this.naacNewsSuccess = false;
    this.newsId = null;
    this.newsTitle = null
    this.newsDesc = null
    this.newsLink = null
    this.newsSearchKey = null
    this.saveNews = true;
    this.firstEditNews = true;
    this.saveAndUpdateNews = false;
    this.newsLinkValid = false
    this.LandingPaginationDTO.searchTerm = '';
    this.isUploadnewsImage = false;
    document.getElementById("filenamenewsImage").textContent = this.fileTypeConstant;
    document.getElementById("base64textareanewsImage").textContent = '';
    this.uploadFileNamenewsImage = null;
    this.naacNewsImage = '';

  }
  // to delete naac details
  resetnaacDetails() {
    this.clearAlerts();
    this.method = "onResetnaacDetails";
    this.param = '';
    this.msg1 = this.msg2Constant;
  }

  onResetnaacDetails() {

    setTimeout(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }, 200);
    this.deleteNews = false;
    this.deletenaacDetails();

  }


  deletenaacDetails() {
    this.naacAffinity = null;
    this.naacVision = null;
    this.uploadFileNameBanner = '';
    this.naacBannerImage = '';
    this.isbannerimageLoaded = false;
    this.bannerImageExtensionError = false;
    this.selectedFileforBanner = null;
    this.uploadFileNameBanner = this.fileTypeConstant;
    this.isUploadBannerImage = false;
    this.isLoaderBannerStop = false;
    this.isbannerimageLoaded = false;
    this.deleteSuccess = false;
    this.naacDetailsSuccess = false;
    this.naacDetailsUpdate = false;
    this.naacLogoImage = '';
    this.uploadFileNamenaacLogo = null;
    document.getElementById("base64textareanaacLogo").textContent = '';
    document.getElementById("filenamenaacLogo").textContent = this.fileTypeConstant;
  }

  /** to reset resource
   * @class NaacComponent
   * @method resetResource
   */
  resetResource() {
    this.clearAlerts();
    this.method = "onResetResourceClick";
    this.param = '';
    this.msg1 = this.msg2Constant;
  }

  onResetResourceClick() {
    setTimeout(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }, 200);
    this.deleteResource = false;
    this.deleteResetResource();
    this.getNaacResouceList();
    this.getNaacFolderList();

  }

  deleteResetResource() {
    this.addResouceTitle = null
    this.additionalDesc = null
    this.addResourceDocument = null
    this.resourceOrder = null
    this.resourceSearchKey = null;
    this.LandingPaginationDTO.searchTerm = '';
    this.naacResourceSuccess = false;
    this.naacResourceId = '0';
    this.saveAndUpdateResource = false;
    this.saveResource = true;
    this.errorMessageResourceActive = false;
    this.ResourcefileName = this.uploadDocumentType;
    this.isFileUploded = false;
    this.selectedFile = null;
    this.fileSizeExtensionError = false;
    this.UploadDocument = null;
    this.errorMsgUploadSave = false;
    this.errorMsgUploadSaveUpdate = false;
    this.selectedFolder = null;
    this.folderName = '';
    this.folderId = null;
  }


  /** to reset reTeam
   * @class NaacComponent
   * @method resetReTeam
   */
  resetReTeam() {
    this.clearAlerts();
    this.method = "onResetReTeamClick";
    this.param = '';
    this.msg1 = this.msg2Constant;

  }
  onResetReTeamClick() {
    setTimeout(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }, 200);
    this.deleteRegional = false;
    this.myInputVariable.nativeElement.value = "";
    this.deleteResetReTeam();
    this.getnaacREteam();
    this.imageChangedEvent = '';
    this.croppedImage = '';
    this.uploadFileExtensionUser = false;
    document.getElementById("base64textareaUser").textContent = '';
    document.getElementById("filenameUserPic").textContent = this.fileTypeConstant;
    this.myInputVariable.nativeElement.value = '';
    this.isUploadImage = false;
    this.isLoaderStop = false;
    this.naacUserImage = null;
  }

  deleteResetReTeam() {
    this.userList = null;
    this.regionalDesignation = null
    this.userId = null
    this.userFirstName = null
    this.searchTerm = null
    this.emailId = null
    this.userPic = null
    this.reTeamOrder = null
    this.reTeamSearchKey = null;
    this.LandingPaginationDTO.searchTerm = '';
    this.naacReteamSuccess = false;
    this.naacUserImage = null;
    this.naacReTeamId = '0';
    this.reTeamEamilValid = false;
    this.uploadFileExtensionUser = false
    this.errorMessageRegionalActive = false;
    this.naacPronoun = '';
    if (this.lbl !== undefined) {
      this.lbl.innerText = "JPEG or PNG (400 x 200)";
    }
    document.getElementById("base64textareaUser").textContent = '';
    document.getElementById("filenameUserPic").textContent = this.fileTypeConstant;
    this.saveReTeam = true;
    this.saveAndUpdateReTeam = false;
    this.butDisabled = true
  }

  /** action on click of naac master tab
  * @class NaacComponent
  * @method naacMaster
  */
  naacMaster() {
    setTimeout(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }, 200);
    this.isNewsPageClicked = false;
    this.isResourcePageClicked  = false;
    this.isRegionalPageClicked  = false;

    this.affinitySuccess = false;
    this.affinityUpdate = false;
    this.errorAffinity = false;
    this.affinityTable = true;
    this.deleteAffinity = false;
    this.naacPublishSuccess = false;
    this.naacDetailsUpdate = false;

    this.naacNewsTable = false;
    this.naacResourceTable = false;
    this.naacReTeamTable = false;



    this.naacNewsSuccess = false;
    this.naacResourceSuccess = false;
    this.naacReteamSuccess = false;


    this.deleteNews = false;
    this.deleteResource = false;
    this.deleteRegional = false;

    this.errorMessageResourceActive = false;
    this.errorMessageRegionalActive = false;

    this.userFound = false;
    this.noUser = false
    this.LandingPaginationDTO.searchTerm = '';
    this.newsSearchKey = '';
    this.resourceSearchKey = '';
    this.reTeamSearchKey = '';

    this.searchTerm = '';
    this.currentPage = 1;
    this.errorMsgUploadSave = false;
    this.errorMsgUploadSaveUpdate = false;

    this.getnaacAffinityList();

  }

  /** action on click of naac news tab
 * @class NaacComponent
 * @method naacMaster
 */
  naacNews() {
    setTimeout(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }, 200);
    this.isNewsPageClicked = true;
    this.isResourcePageClicked  = false;
    this.isRegionalPageClicked  = false;

    this.affinitySuccess = false;
    this.affinityUpdate = false;
    this.errorAffinity = false;
    this.deleteAffinity = false;
    this.naacPublishSuccess = false;
    this.naacDetailsUpdate = false;

    this.currentPage = 1;
    this.LandingPaginationDTO.page = 0;
    this.naacNewsTable = true;
    this.naacResourceTable = false;
    this.naacReTeamTable = false;
    this.affinityTable = false;



    this.naacDetailsUpdate = false;
    this.naacDetailsSuccess = false;
    this.naacNewsSuccess = false;
    this.naacReteamSuccess = false;

    this.naacResourceSuccess = false;

    this.deleteNews = false;
    this.deleteResource = false;
    this.deleteRegional = false;


    this.userFound = false;
    this.noUser = false


    this.errorMessageResourceActive = false;
    this.errorMessageRegionalActive = false;

    this.LandingPaginationDTO.searchTerm = '';
    this.newsSearchKey = '';
    this.resourceSearchKey = '';
    this.reTeamSearchKey = '';

    this.searchTerm = '';
    this.errorMsgUploadSave = false;
    this.errorMsgUploadSaveUpdate = false;


  }

  /** get list of naac affinity
* @class NaacComponent
* @method getnaacAffinityList
*/
  getnaacAffinityList() {
    this.spinnerService.show();
    this.LandingPaginationDTO.size = ConstantValues.pageLimit;
    const LandingPaginationDTO = {
      "filter": { "naacFlag": "naacSelfService",
      "adminId":this.adminId,
      "userId" : this.loginDetails.userId
 },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 500,
      "sortDirection": "ASC",
      "sortProperty": "naacId",
      "uid": "",
      
    }

    this.naacService.getnaacAffinityList(LandingPaginationDTO).subscribe(data => {
      this.naacAffinityList = data;
      if (this.naacAffinityList.length > 0) {
        for (const naac of this.naacAffinityList) {
          if (localStorage.getItem("naacId") === naac.naacId && this.isFolderSectionClicked === true) {
            this.onEditNaacClick(naac);
            break;
          }
        }
      }
      if (this.naacAffinityList.length === 0) {
        this.noAffinityTable = true;
      }
      else {
        this.noAffinityTable = false;
      }

      this.numberOfElements = this.naacAffinityList.length;
      this.spinnerService.hide();
      if ((this.currentPage * this.limit) < this.numberOfElements) {
        this.currentShowingElementsAffinity = this.currentPage * this.limit;
      } else if ((this.currentPage * this.limit) >= this.numberOfElements) {

        this.currentShowingElementsAffinity = this.numberOfElements;
      }
    })

  }

  /** get list of naac news
  * @class NaacComponent
  * @method getnaacnewsList
  */
  getnaacnewsList() {
    this.spinnerService.show();
    this.LandingPaginationDTO.size = ConstantValues.pageLimit;
    this.LandingPaginationDTO = {
      "filter": { "naacFlag": "naacSelfService" },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": this.newsSearchKey,
      "size": 500,
      "sortDirection": "ASC",
      "sortProperty": "modifiedDateTime",
      "uid": ""
    }

    this.naacService.getnaacnewsList(this.LandingPaginationDTO).subscribe(data => {
      this.naacNewsList = data.content;
      if (this.naacNewsList.length === 0) {
        this.noNewsTable = true;
      }
      else {
        this.noNewsTable = false;
        this.tableShow = true;
        this.selectedNews = [];
        for (const news of this.naacNewsList) {
          if (this.naacId === news.naacId) {
            this.selectedNews.push(news)
            if(this.selectedNews.length === 0)
            {
              this.noNewsTable = true;
            }
          }
        }

      }

      this.numberOfElements = this.selectedNews.length;
      this.spinnerService.hide();
      if ((this.currentPage * this.limit) < this.numberOfElements) {
        this.currentShowingElementsNews = this.currentPage * this.limit;
      } else if ((this.currentPage * this.limit) >= this.numberOfElements) {

        this.currentShowingElementsNews = this.numberOfElements;
      }
    })

  }


  /** action on click of Naac resource tab
  * @class NaacComponent
  * @method naacResource
  */
  naacResource() {
    setTimeout(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }, 200);
    this.isNewsPageClicked = false;
    this.isResourcePageClicked  = true;
    this.isRegionalPageClicked  = false;

    this.affinitySuccess = false;
    this.affinityUpdate = false;
    this.errorAffinity = false;
    this.deleteAffinity = false;
    this.naacPublishSuccess = false;
    this.naacDetailsUpdate = false;

    this.currentPage = 1;
    this.LandingPaginationDTO.page = 0;


    this.naacNewsTable = false;
    this.naacResourceTable = true;
    this.naacReTeamTable = false;
    this.affinityTable = false;


    this.naacDetailsSuccess = false;
    this.naacNewsSuccess = false;
    this.naacReteamSuccess = false;
    this.naacDetailsUpdate = false;

    this.deleteNews = false;
    this.deleteResource = false;
    this.deleteRegional = false;

    this.userFound = false;
    this.noUser = false

    this.errorMessageRegionalActive = false;
    this.LandingPaginationDTO.searchTerm = '';
    this.newsSearchKey = '';
    this.resourceSearchKey = '';
    this.reTeamSearchKey = '';

    this.searchTerm = '';

    this.getNaacResouceList();
    this.getNaacFolderList();
    this.errorMsgUploadSave = false;
    this.errorMsgUploadSaveUpdate = false;

  }

  /** get list of naac resource
  * @class NaacComponent
  * @method getNaacResouceList
  */
  getNaacResouceList() {
    this.spinnerService.show()
    this.LandingPaginationDTO.size = ConstantValues.pageLimit;

    this.LandingPaginationDTO = {
      "filter": { "naacFlag": "naacSelfService" },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": this.resourceSearchKey,
      "size": 500,
      "sortDirection": "ASC",
      "sortProperty": "folderOrder",
      "uid": ""
    }

    this.naacService.getnaacResource(this.LandingPaginationDTO).subscribe(data => {
      this.naacResouceList = data.content

      if (this.naacResouceList.length === 0) {
        this.noResourceTable = true
      }
      else {
        this.selectedResource = [];
        this.noResourceTable = false;
        this.tableShow = true;
        for (const resource of this.naacResouceList) {
          if (this.naacId === resource.naacId) {
            this.selectedResource.push(resource)
          }
        }
if(this.selectedResource.length ===0)
{
  this.noResourceTable = true
}

      }
      this.numberOfElements = this.selectedResource.length;
      this.spinnerService.hide();
      if ((this.currentPage * this.limit) < this.numberOfElements) {
        this.currentShowingElementsResource = this.currentPage * this.limit;
      } else if ((this.currentPage * this.limit) >= this.numberOfElements) {

        this.currentShowingElementsResource = this.numberOfElements;
      }
    })

  }

  /** get list of naac Folders
* @class NaacComponent
* @method getNaacFolderList
*/
  getNaacFolderList() {
    this.landingData = {
      "filter": {},
      "moduleId": 0,

      "presentRole": "",
      "searchTerm": "",
      "size": 50,
      "sortDirection": "DESC",
      "sortProperty": "created_date_time",
      "uid": ""
    }

    this.naacService.getNaacDocumentsFolder(this.landingData).subscribe(data => {
      const folderNameList = data.content;
      this.folderNameList = [];
      for (const folder of folderNameList) {
        if (folder.naacId === this.naacId) {
          this.folderNameList.push(folder)
        }
      }
    })
  }


  /** action on click of naac reTeam tab
  * @class NaacComponent
  * @method naacReTeam
  */
  naacReTeam() {
    setTimeout(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }, 200);

    this.isNewsPageClicked = false;
    this.isResourcePageClicked  = false;
    this.isRegionalPageClicked  = true;

    this.affinitySuccess = false; this.affinityUpdate = false;
    this.affinityUpdate = false;
    this.errorAffinity = false;
    this.deleteAffinity = false;
    this.naacPublishSuccess = false;
    this.naacDetailsUpdate = false;

    this.currentPage = 1;
    this.LandingPaginationDTO.page = 0;

    this.naacNewsTable = false;
    this.naacResourceTable = false;
    this.naacReTeamTable = true;
    this.affinityTable = false;



    this.naacDetailsSuccess = false;
    this.naacNewsSuccess = false;
    this.naacReteamSuccess = false;
    this.naacDetailsUpdate = false;
    this.naacResourceSuccess = false;

    this.deleteNews = false;
    this.deleteResource = false;
    this.deleteRegional = false;


    this.errorMessageResourceActive = false;


    this.LandingPaginationDTO.searchTerm = '';
    this.newsSearchKey = '';
    this.resourceSearchKey = '';
    this.reTeamSearchKey = '';

    this.searchTerm = '';
    this.errorMsgUploadSave = false;
    this.errorMsgUploadSaveUpdate = false;


  }

  /** action on click of naac dashboard tab
* @class NaacComponent
* @method naacReTeam
*/
  naacDashboard() {
    setTimeout(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }, 200);
  this.isNewsPageClicked = false;
  this.isResourcePageClicked  = false;
  this.isRegionalPageClicked  = false;

    this.affinitySuccess = false;
    this.affinityUpdate = false;
    this.naacDetailsUpdate = false;
    this.errorAffinity = false;
    this.deleteAffinity = false;
    this.naacPublishSuccess = false;

    this.currentPage = 1;
    this.LandingPaginationDTO.page = 0;

    this.naacNewsTable = false;
    this.naacResourceTable = false;
    this.naacReTeamTable = false;
    this.affinityTable = false;



    this.naacDetailsSuccess = false;
    this.naacNewsSuccess = false;
    this.naacReteamSuccess = false;
    this.naacResourceSuccess = false;
    this.naacDetailsUpdate = false;
    this.deleteNews = false;
    this.deleteResource = false;
    this.deleteRegional = false;


    this.errorMessageResourceActive = false;


    this.LandingPaginationDTO.searchTerm = '';
    this.newsSearchKey = '';
    this.resourceSearchKey = '';
    this.reTeamSearchKey = '';

    this.searchTerm = '';
    this.errorMsgUploadSave = false;
    this.errorMsgUploadSaveUpdate = false;


  }

  findbyEmail(e){
    const text = e.target.value;
    if(text.length>2){
     this.searchTerm = text;
     this.searchBy();
    }else{
      this.userList = [];
    }
  }
  /** get list of naac Reteam
   * @class NaacComponent
   * @method getnaacREteamList
   */
  getnaacREteam() {
    if (this.searchTerm != null && (this.reTeamSearchKey === null || this.reTeamSearchKey === '')) {
      this.LandingPaginationDTO.searchTerm = '';
    }
    this.spinnerService.show();

    this.LandingPaginationDTO.size = ConstantValues.pageLimit;
    this.LandingPaginationDTO = {
      "filter": { "naacFlag": "naacSelfService" },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": this.reTeamSearchKey,
      "size": 500,
      "sortDirection": "ASC",
      "sortProperty": "regionalOrder",
      "uid": ""
    }

    this.naacService.getnaacREteam(this.LandingPaginationDTO).subscribe(data => {
      this.naacReTeamList = data.content;
      if (this.naacReTeamList.length === 0) {
        this.noReginalTbale = true;
        this.tableShow = true;
      }
      else {
        this.noReginalTbale = false;
        this.selectedReteam = [];
        for (const re of this.naacReTeamList) {
          if (this.naacId === re.naacId) {
            this.selectedReteam.push(re)
          }
        }
      }
      if(this.selectedReteam.length === 0)
      {
        this.noReginalTbale = true;
      }
      this.numberOfElements = this.selectedReteam.length;
      if ((this.currentPage * this.limit) < this.numberOfElements) {
        this.currentShowingElementsReTeam = this.currentPage * this.limit;
      } else if ((this.currentPage * this.limit) >= this.numberOfElements) {

        this.currentShowingElementsReTeam = this.numberOfElements;
      }
    })
    this.spinnerService.hide();

  }


  /** to select the user pic
   * @class NaacComponent
   * @method onUserPicSelected
   */
  onUserPicSelected(event) {
    const files = event.target.files;
    const file = files[0];
    this.uploadFileNameUser = file.name;

    if (this.width === 400 && this.height === 400) {
      this.uploadFileExtensionUser = false;
    } else {
      this.uploadFileExtensionUser = true;
    }
    const image: any = event.target.files[0];
    const fr: any = new FileReader();
    fr.onload = () => { // when file has loaded
      const img = new Image();
      img.onload = () => {
        this.width = img.width;
        this.height = img.height;
        if (this.width === 400 && this.height === 400) {
          this.uploadFileExtensionUser = false;
        } else {
          this.uploadFileExtensionUser = true;
        }
      };
      img.src = fr.result; // This is the data URL

    };
    fr.readAsDataURL(image);

    this.lbl = document.getElementById('filenameUserPic');
    this.lbl.innerText = this.uploadFileNameUser;
    if (files && file) {
      this.naacUserImage = "";
      let imageData: any = '';
      const reader: any = new FileReader();
      if (reader.readAsBinaryString) {
        reader.onloadend = function (readerEvt) {
          const binaryString = readerEvt.target.result;
          imageData = btoa(binaryString);
          document.getElementById("base64textareaUser").textContent = imageData;
        };
        this.naacUserImage = imageData;
        reader.readAsBinaryString(file);
      } else { //IE 10 or 11
        let binary = "";
        reader.onload = function (e) {
          const bytes = new Uint8Array(e.target.result);
          const length = bytes.byteLength;
          for (let i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          //binary - readonly so assign content to another property
          imageData = btoa(binary);
          document.getElementById("base64textareaUser").textContent = imageData;
        }
        this.naacUserImage = imageData;
        reader.readAsArrayBuffer(file);
      }
    }
  }



  /** on news page changed
    * @class NaacComponent
    * @method onNaacSelected
    */
  pageNewsChanged(event) {
    this.LandingPaginationDTO.page = event - 1;
    this.currentPage = event;
    if ((this.currentPage * this.limit) < this.numberOfElements) {
      this.currentShowingElementsNews = this.currentPage * this.limit;
    } else if ((this.currentPage * this.limit) >= this.numberOfElements) {
      this.currentShowingElementsNews = this.numberOfElements;
    }
    this.getnaacnewsList();
  }

  /** on news page changed
  * @class NaacComponent
  * @method pageAffinityChanged
  */
  pageAffinityChanged(event) {
    this.LandingPaginationDTO.page = event - 1;
    this.currentPage = event;
    if ((this.currentPage * this.limit) < this.numberOfElements) {
      this.currentShowingElementsAffinity = this.currentPage * this.limit;
    } else if ((this.currentPage * this.limit) >= this.numberOfElements) {
      this.currentShowingElementsAffinity = this.numberOfElements;
    }
    this.getnaacAffinityList();
  }

  /** on resource page changed
  * @class DIComponent
  * @method pageResourceChanged
  */
  pageResourceChanged(event) {
    this.LandingPaginationDTO.page = event - 1;
    this.currentPage = event;
    if ((this.currentPage * this.limit) < this.numberOfElements) {
      this.currentShowingElementsResource = this.currentPage * this.limit;
    } else if ((this.currentPage * this.limit) >= this.numberOfElements) {
      this.currentShowingElementsResource = this.numberOfElements;
    }
    this.getNaacResouceList();
    this.getNaacFolderList();
  }

  /** on reTeam page changed
 * @class DIComponent
 * @method pageReteamChanged
 */
  pageReteamChanged(event) {
    this.LandingPaginationDTO.page = event - 1;
    this.currentPage = event;
    if ((this.currentPage * this.limit) < this.numberOfElements) {
      this.currentShowingElementsReTeam = this.currentPage * this.limit;
    } else if ((this.currentPage * this.limit) >= this.numberOfElements) {
      this.currentShowingElementsReTeam = this.numberOfElements;
    }
    this.getnaacREteam();
  }

  /** on naac page changed
 * @class DIComponent
 * @method pageNaacChanged
 */
  pageNaacChanged(event) {
    this.LandingPaginationDTO.page = event - 1;
    this.currentPage = event;
    if ((this.currentPage * this.limit) < this.numberOfElements) {
      this.currentShowingElementsNaac = this.currentPage * this.limit;
    } else if ((this.currentPage * this.limit) >= this.numberOfElements) {
      this.currentShowingElementsNaac = this.numberOfElements;
    }
  }

  /** For searching the user
 * @class NaacComponent
 * @method searchBy
 */

  searchBy() {
    this.clearAlerts();
    this.spinnerService.show();
    this.search = true;
    this.searchTerm = (this.searchTerm) ? this.searchTerm : '';
    this.LandingPaginationDTO.searchTerm = this.searchTerm;
    this.getUserList();
    this.spinnerService.hide();
  }

  /** For searching the news
 * @class DIComponent
 * @method searchNewsMe
 */
  searchNewsMe() {
    this.clearAlerts();
    this.spinnerService.show();
    this.newsSearchKey = (this.newsSearchKey) ? this.newsSearchKey : '';
    this.LandingPaginationDTO.page = 0;
    this.LandingPaginationDTO.searchTerm = this.newsSearchKey;
    this.currentPage = 1;
    this.getnaacnewsList();
    this.spinnerService.hide();
  }


  /** For searching the resource
 * @class NaacComponent
 * @method searchResourceMe
 */
  searchResourceMe() {
    this.clearAlerts();
    this.spinnerService.show();
    this.resourceSearchKey = (this.resourceSearchKey) ? this.resourceSearchKey : '';
    this.LandingPaginationDTO.page = 0;
    this.LandingPaginationDTO.searchTerm = this.resourceSearchKey;
    this.currentPage = 1;
    this.getNaacResouceList();
    this.getNaacFolderList();
    this.spinnerService.hide();
  }


  /** For searching the reTeam
 * @class DIComponent
 * @method searchReTeamMe
 */
  searchReTeamMe() {
    this.clearAlerts();
    this.spinnerService.show();
    this.reTeamSearchKey = (this.reTeamSearchKey) ? this.reTeamSearchKey : '';
    this.LandingPaginationDTO.page = 0;
    this.LandingPaginationDTO.searchTerm = this.reTeamSearchKey;
    this.currentPage = 1;
    this.getnaacREteam();
    this.spinnerService.hide();
  }


  /** to Delete naac
* @class NaacComponent
* @method deleteNaac
*/
  public deleteNaac(id, flag, i) {
    document.getElementById('deleteNaac' + i).setAttribute(this.dataToggleConstant, 'modal');
    document.getElementById('deleteNaac' + i).setAttribute(this.dataTargetConstant, '#myModal');
    this.method = "deleteAllNaac";
    this.param = id;
    this.param1 = flag;
    this.msg1 = "  Are you sure you want to delete ? ";
  }


  deleteAllNaac(id, flag) {
    const dleteData = {
      "id": id,
      "flag": flag
    }

    this.naacService.deletenaac(dleteData).subscribe(data => {
      if (data.flag === "news") {
        this.deleteNews = true
        this.deleteResetNews();
        this.getnaacnewsList();
        setTimeout(() => {
          window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 200);
      }
      else if (data.flag === "resource") {
        this.deleteResource = true;
        this.deleteResetResource();
        this.getNaacResouceList();
        this.getNaacFolderList();
        setTimeout(() => {
          window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 200);
      }
      else if (data.flag === "regional") {
        this.deleteRegional = true;
        this.deleteResetReTeam();
        this.getnaacREteam();
        setTimeout(() => {
          window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 200);
      }
      else {

        setTimeout(() => {
          window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 200);
      }

    })

  }




  /** to edit news
* @class DIComponent
* @method editNaac
*/

  editNaac(data) {
    this.method = "onEditNaacClick";
    this.param = data;
    this.msg1 = this.msg2Constant;

  }
  onEditNaacClick(data) {
    this.resetDashboard();
    this.onResetnaacDetails();
    this.onResetNewsClick();
    this.onResetResourceClick();
    this.onResetReTeamClick();
    this.selectedNews = [];
    this.selectedReteam = [];
    this.selectedResource = [];
    this.naacEdit = true;
    this.naacId = data.naacId;
    localStorage.setItem("naacId", this.naacId);
    if (data.naacId != null) {

      //dashboard section
      this.selectedBpg = data.naacAffinityId;
      this.naacDate = data.naacDate ? new Date(data.naacDate.replace('-', '/')) : null;

      //details section
      if (this.bannerResponseList.length > 0) {
        for (const banner of this.bannerResponseList) {
          if (data.naacId === banner.naacId) {
            this.isbannerimageLoaded = true;
            this.naacVision = banner.naacVision;
            this.naacAffinity = banner.naacAffinity;
            this.uploadFileNameBanner = banner.naacBanner;
            this.naacBannerId = banner.naacBannerId;
            document.getElementById("filenamenaacLogo").textContent = banner.naacLogo;
            this.uploadnaacLogoDone = false;
            this.naacLogo = banner.naacLogo;
            this.uploadFileNamenaacLogo = banner.naacLogo;
          }
        }
      }
      //news section
      if (this.naacNewsList.length > 0) {
        for (const news of this.naacNewsList) {
          if (data.naacId === news.naacId) {

            this.selectedNews.push(news)
          }
        }
      }
      //RE Team
      if (this.naacReTeamList.length > 0) {
        for (const team of this.naacReTeamList) {
          if (data.naacId === team.naacId) {
            this.selectedReteam.push(team)
          }
        }
      }
      // Resource Team
      if (this.naacResouceList.length > 0) {
        for (const re of this.naacResouceList) {
          if (data.naacId === re.naacId) {
            this.selectedResource.push(re)
          }
        }
      }
    }
  }


  /** to delete news Image
   * @class naacComponent
   * @method removeFile
   */
  removeFile() {
    this.isUploadnewsImage = false;
    document.getElementById("filenamenewsImage").textContent = this.fileTypeConstant;
    document.getElementById("base64textareanewsImage").textContent = '';
    this.uploadFileNamenewsImage = null;
    this.isLoadernewsImageStop = false;
    this.naacNewsImage = '';
    this.uploadnewsImageDone = true;
    this.uploadFileExtensionNewsImage = false;
    this.imageCheck = false;

  }
  /** to delete full naac
* @class naacComponent
* @method naacDelete
// */

  public OnnaacDeleteConfirmation(naacId) {

    this.method = "naacDelete";
    this.param = naacId;
    this.msg1 = " Are you sure you want to delete the NAAC? ";

  }
  naacDelete(naacId) {
    this.spinnerService.show();
    this.naacService.deleteNaacAffinity(naacId).subscribe(_data => {
      this.spinnerService.hide();
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      this.deleteAffinity = true;
      this.resetDashboard();
      this.onResetnaacDetails();
      this.onResetNewsClick();
      this.onResetResourceClick();
      this.onResetReTeamClick();
      this.getnaacAffinityList();
     
    });
  }

  /** to edit news
* @class DIComponent
* @method editNews
*/
  editNews(data, i) {
    if (this.newsTitle != null || this.newsLink != null) {
      this.firstEditNews = false;
    }
    if (this.firstEditNews === true) {
      this.firstEditNews = false;
      this.editNewsData(data);
    } else {
      document.getElementById('editN' + i).setAttribute(this.dataToggleConstant, 'modal');
      document.getElementById('editN' + i).setAttribute(this.dataTargetConstant, '#myModal');
      this.method = "editNewsData";
      this.param = data;
      this.msg1 = this.msg2Constant;
    }
  }

  editNewsData(data) {
    this.newsTitle = data.naacNewsTitle;
    this.newsDesc = data.naacNewsDesc;
    this.newsLink = data.naacNewsLink;
    this.newsId = data.naacNewsId;
    this.imageCheck = data.naacImageCheck;
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    this.saveNews = false;
    this.saveAndUpdateNews = true;
    this.naacNewsSuccess = false;
    document.getElementById("filenamenewsImage").textContent = data.naacNewsName.length > 13 ? data.naacNewsName.substring(13,) : this.fileTypeConstant;

  }

  /** to edit resource
  * @class DIComponent
  * @method editResource
  */
  editResource(data, i) {
    if (this.addResouceTitle != null || this.addResourceDocument != null) {
      this.firstEditResource = false;
    }
    if (this.firstEditResource === true) {
      this.firstEditResource = false;
      this.editResourceData(data);
    } else {
      document.getElementById('editR' + i).setAttribute(this.dataToggleConstant, 'modal');
      document.getElementById('editR' + i).setAttribute(this.dataTargetConstant, '#myModal');
      this.method = "editResourceData";
      this.param = data;
      this.msg1 = this.msg2Constant;
    }
  }

  editResourceData(data) {
    this.errorMsgUploadSaveUpdate = false;
    this.errorMsgUploadSave = false;
    this.isFileUploded = true;
    this.addResouceTitle = data.naacResourceTitle;
    this.additionalDesc = data.naacResourceDesc;
    this.ResourcefileName = data.naacResourceDocument
    this.resourceOrder = data.resourceOrder;
    this.naacResourceId = data.naacResourceId;
    this.selectedFile = null;
    this.UploadDocument = data.naacResourceDocument;
    this.selectedFolder = data.folderId;
    this.folderName = data.folderName;
    this.folderId = data.folderId;
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    this.saveResource = false;
    this.saveAndUpdateResource = true;
    this.naacResourceSuccess = false;
  }

  /** to edit reTeam
  * @class DIComponent
  * @method editReTeam
  */
  editReTeam(data, i) {
    if (this.regionalDesignation != null || this.emailId != null) {
      this.firstEditReTeam = false;
    }
    if (this.firstEditReTeam === true) {
      this.firstEditReTeam = false;
      this.editReTeamData(data);
    } else {
      document.getElementById('editRt' + i).setAttribute(this.dataToggleConstant, 'modal');
      document.getElementById('editRt' + i).setAttribute(this.dataTargetConstant, '#myModal');
      this.method = "editReTeamData";
      this.param = data;
      this.msg1 = this.msg2Constant;
    }
  }

  editReTeamData(data) {
    this.butDisabled = false;
    this.noUser = false;
    this.userFound = false;
    this.showReset = true;
    this.searchTerm = null

    this.RePic = document.getElementById('filenameUserPic');
    this.uploadFileNameUser = data.userPic;
    if (this.uploadFileNameUser != null && this.uploadFileNameUser !== undefined && this.uploadFileNameUser.trim() !== "") {
      const b = this.uploadFileNameUser;
      this.RePic.innerText = b;
    }
    this.naacUserImage = '';
    this.userFirstName = data.userName;
    this.regionalDesignation = data.roleName;
    this.emailId = data.emailId;
    this.userPic = data.userPic;
    this.reTeamOrder = data.regionalOrder;
    this.naacReTeamId = data.naacReTeamId;
    this.userId = data.userId;
    this.naacPronoun = data.naacPronounce;
    if (data.siteName.length > 0) {
      this.siteName = data.siteNameList;
    }
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    this.saveReTeam = false;
    this.saveAndUpdateReTeam = true;
    this.naacReteamSuccess = false;
  }



  /** link validation
* @class DIComponent
* @method onLinkType
*/
  onLinkType(event, type) {
    const re = /^(https?:\/\/)?(www.\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,5}.?/;
    if (re.test(String(event.target.value).toLowerCase()) === false) {
      if (type === 'news') {
        if (event.target.value !== "") {
          this.newsLinkValid = true;
        }
      }

    }
    else if (type === 'news') {
        this.newsLinkValid = false;
      }
  }


  /** email validation
* @class NaacComponent
* @method onEmailType
*/
  onEmailType(event) {
    const re = new RegExp(/^(?!\.)[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@(?!-)[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/);
    if (re.test(String(event.target.value).toLowerCase()) === false) {
      if (this.butDisabled === false) {
        this.reTeamEamilValid = true;
      }
    }
    else {
      this.reTeamEamilValid = false;
    }
  }

  /** checks if word exists in array
 * @class ConfigureGalleryComponent
 * @method isInArray
 */
  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }

  public onFileSelectedBanner(event) {
    if (event.target.files.length > 0) {
      this.isUploadBannerImage = true;
      this.isLoaderBannerStop = true;
      this.imageChangedEventBanner = event;
      this.imageTypeName = 'bannerImage';

      this.selectedFileforBanner = null;
      this.fileSizeExtensionError = false;
      this.deleteSuccess = false;
      if (event.target.files[0].type !== "image/png" && (event.target.files[0].type !== this.fileType1Constant))
      {
        this.bannerImageExtensionError = true;
      }
      if (event.target.files[0].type === "image/png" || event.target.files[0].type === this.fileType1Constant) {
        this.bannerImageExtensionError = false;
        this.selectedFileforBanner = event.target.files[0] as File;

        this.uploadFileNameBanner = this.selectedFileforBanner.name;
      }


    }
  }

  /** on resource file selected
* @class DIComponent
* @method onFileSelected
*/
  public onFileSelected(event) {
    this.isFileUploded = true;
    if (event.target.files.length > 0) {
      this.ResourcefileName = event.target.files[0].name;
      this.fileSize = event.target.files[0].size;
      this.fileExtension = this.ResourcefileName.split('.').pop();

      if (this.fileSize >= 524288000) {
        this.fileSizeExtensionError = true;
      } else {
        this.fileSizeExtensionError = false;
        this.selectedFile = event.target.files[0] as File;
        this.UploadDocument = this.selectedFile.name;
      }

    }
  }

  fileChangeEvent(event: any, imageType): void {
    const files = event.target.files;
    const file = files[0];
    this.imageTypeName = imageType;
    if (file.type !== "image/png" && file.type !== this.fileType1Constant) {
      if (this.imageTypeName === 'userPic') {
        this.uploadFileExtensionUser = true;
        this.myInputVariable.nativeElement.value = '';
      } else if (this.imageTypeName === 'bannerImage') {
        this.uploadFileExtension = true;
        this.myInputBannerVariable.nativeElement.value = '';
      } else if (this.imageTypeName === 'naacLogo') {
        this.uploadFileExtensionnaacLogo = true;
      } else if (this.imageTypeName === 'newsImage') {
        this.uploadFileExtensionNewsImage = true;
      } 
    } else {
      this.imageChangedEvent = event;
      if (this.imageTypeName === 'userPic') {
        this.uploadFileExtensionUser = false;
        this.uploadFileNameUser = file.name;
        document.getElementById("filenameUserPic").textContent = this.uploadFileNameUser;
        this.isLoaderUserPicStop = false;
        this.uploadUserPicImageDone = true;
        this.isUploadUserPicImage = true;
      } else if (this.imageTypeName === 'bannerImage') {
        this.uploadFileExtension = false;
        this.isLoaderStop = false;
        this.uploadImageDone = true;
        this.isUploadImage = true;
      }
      else if (this.imageTypeName === 'naacLogo') {
        this.uploadFileNamenaacLogo = file.name;
        this.isLoaderNaacLogoStop = false;
        this.uploadFileExtensionnaacLogo = false;
        this.isUploadnaacLogoImage = true;
        this.uploadnaacLogoDone = true;
        document.getElementById("filenamenaacLogo").textContent = this.uploadFileNamenaacLogo;
      }
      else if (this.imageTypeName === 'newsImage') {
        this.uploadFileNamenewsImage = file.name;
        this.isUploadnewsImage = true;
        this.isLoadernewsImageStop = false;
        this.uploadFileExtensionNewsImage = false;
        this.uploadnewsImageDone = true;
        document.getElementById("filenamenewsImage").textContent = this.uploadFileNamenewsImage;
        if (event.target.files && event.target.files.length) {
          const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
              const img = new Image();
              img.src = reader.result as string;
              img.onload = () => {
                this.newsImageHeight = img.naturalHeight.toString();
                this.newsImageWidth = img.naturalWidth.toString();
               };
            };
       }
      } 
    }
  }
  imageCropped(event: ImageCroppedEvent) {

    this.croppedImage = event.base64.replace(/^data:image\/[a-z]+;base64,/, "");
    if (this.imageTypeName === 'userPic') {
      document.getElementById("base64textareaUser").textContent = this.croppedImage;
      this.naacUserImage = this.croppedImage;
      this.uploadUserPicImageDone = true;
    } else if (this.imageTypeName === 'bannerImage') {

      this.naacBannerImage = this.croppedImage;
    }
    else if (this.imageTypeName === 'naacLogo') {
      document.getElementById("base64textareanaacLogo").textContent = this.croppedImage;
      this.naacLogoImage = this.croppedImage;
      this.uploadnaacLogoDone = true;
    } else if (this.imageTypeName === 'newsImage') {
      this.naacNewsImage = this.croppedImage;
      document.getElementById("base64textareanewsImage").textContent = this.croppedImage;
      this.uploadnewsImageDone = true;
    }
    
  }



  imageLoaded() {

    if (this.imageTypeName === 'userPic') {
      this.isLoaderUserPicStop = true;
    } else if (this.imageTypeName === 'bannerImage') {
      this.isLoaderBannerStop = true;
    } else if (this.imageTypeName === 'newsImage') {
      this.isLoadernewsImageStop = true;
    }
    else if (this.imageTypeName === 'naacLogo') {
      this.isLoaderNaacLogoStop = true;
    }
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }

  cancelUploadedImage(imageType) {

    if (imageType === 'userPic') {
      document.getElementById("base64textareaUser").textContent = '';
      document.getElementById("filenameUserPic").textContent = this.fileTypeConstant;
      this.myInputVariable.nativeElement.value = '';
      this.uploadFileExtensionUser = false;
      this.naacUserImage = null;
      this.uploadFileNameUser = null;
      this.isUploadUserPicImage = false;
      this.isLoaderUserPicStop = false;
      ;
    } else if (imageType === 'bannerImage') {
      this.isUploadBannerImage = false;
      this.bannerImageExtensionError = false;
      this.isLoaderBannerStop = false;
      this.imageChangedEventBanner = '';

      this.uploadFileNameBanner = this.fileTypeConstant;
      this.isbannerimageLoaded = false;

    } else if (imageType === 'newsImage') {
      this.isUploadnewsImage = false;
      document.getElementById("filenamenewsImage").textContent = this.fileTypeConstant;
      document.getElementById("base64textareanewsImage").textContent = '';
      this.uploadFileNamenewsImage = null;
      this.isLoadernewsImageStop = false;
      this.naacNewsImage = '';
      this.uploadnewsImageDone = true;
      this.uploadFileExtensionNewsImage = false;


    }
    else if (imageType === 'naacLogo') {
      this.isLoaderNaacLogoStop = false;
      this.uploadFileExtensionnaacLogo = false;
      this.naacLogoImage = '';
      this.isUploadnaacLogoImage = false;
      this.uploadFileNamenaacLogo = null;
      this.uploadnaacLogoDone = true;
      document.getElementById("filenamenaacLogo").textContent = this.fileTypeConstant;
      document.getElementById("base64textareanaacLogo").textContent = '';
    }

    this.imageChangedEvent = '';
    this.croppedImage = '';
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
  }

  doneUploadedImage(imageType) {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    if (imageType === 'userPic') {
      this.myInputVariable.nativeElement.value = '';
      this.uploadFileExtensionUser = false;
      this.uploadUserPicImageDone = false;
      this.isLoaderUserPicStop = false;
      this.isUploadUserPicImage = false;
    } else if (imageType === 'bannerImage') {
      this.isUploadBannerImage = false;
      this.isLoaderBannerStop = false;
      this.isbannerimageLoaded = true;
      this.isLoaderStop = false;
      this.bannerImageExtensionError = false;
    } else if (imageType === 'newsImage') {
      this.isUploadnewsImage = false;
      this.isLoadernewsImageStop = false;
      this.uploadFileExtensionNewsImage = false;
      this.uploadnewsImageDone = false;
      this.uploadFileExtensionNewsImage = false;

    }
    else if (imageType === 'naacLogo') {
      this.myInputVariable.nativeElement.value = '';
      this.isLoaderNaacLogoStop = false;
      this.uploadFileExtensionnaacLogo = false;
      this.isUploadnaacLogoImage = false;
      this.uploadnaacLogoDone = false;
    }

  }

  logUserAction() {
    const data = {
      userId : this.userId,
      categoryDescription : "NAAC"
    };
    this.bpgCommonService.logUserAction(data).subscribe(
      (_data) => {});
  }

}


